import { useSubscription } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetActiveDataExportScheduleDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetActiveDataExportSchedule as useGetActiveDataExportScheduleTRPC } from './useGetActiveDataExportScheduleTRPC';

export const useGetActiveDataExportSchedule = (skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const {
    data: graphqlData,
    loading: graphqlLoading,
    error: graphqlError,
  } = useSubscription(GetActiveDataExportScheduleDocument, {
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip,
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
    error: trpcError,
  } = useGetActiveDataExportScheduleTRPC(skip);

  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: trpcRefetch,
      error: trpcError,
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => Promise.resolve(),
    error: graphqlError,
  };
};
